import { axiosClient } from '@/libs/axios-client';
import {
  extractFileNameFromDisposition,
  saveBlobAsFile,
} from '@/utils/exportUtils';

const BASE = '/zaz';

/** Company settings: { enabled, hiddenFields, hideableFields }. */
export const getZazSettings = async (company) => {
  const { data } = await axiosClient.get(`${BASE}/settings`, {
    params: { company },
  });
  return data;
};

/** { company, enabled, hiddenFields } */
export const updateZazSettings = async (payload) => {
  const { data } = await axiosClient.put(`${BASE}/settings`, payload);
  return data;
};

/**
 * The profile's ZAZ tile: { enabled, isHr, isHead, canSend, heads:
 * [{ name, hasEmail }], sections: [{ key, fields: [{ key, type, options?,
 * required?, max?, min? }] }], items: [zaz] }. 403 for anyone who is neither
 * HR of the company nor a head of the employee's sector (and always for the
 * employee themselves).
 */
export const getEmployeeZaz = async (employeeId) => {
  const { data } = await axiosClient.get(`${BASE}/employee/${employeeId}`);
  return data;
};

/** HR: send to the heads of the sector. { note } */
export const sendZaz = async (employeeId, payload) => {
  const { data } = await axiosClient.post(
    `${BASE}/employee/${employeeId}`,
    payload
  );
  return data;
};

/** HR: reminder, or a returned ZAZ back for completion. */
export const resendZaz = async (employeeId, zazId, payload = {}) => {
  const { data } = await axiosClient.post(
    `${BASE}/employee/${employeeId}/${zazId}/resend`,
    payload
  );
  return data;
};

/** HR: cancel. */
export const cancelZaz = async (employeeId, zazId) => {
  const { data } = await axiosClient.post(
    `${BASE}/employee/${employeeId}/${zazId}/cancel`
  );
  return data;
};

/** Head: save a draft. { answers } */
export const saveZaz = async (employeeId, zazId, answers) => {
  const { data } = await axiosClient.put(
    `${BASE}/employee/${employeeId}/${zazId}`,
    { answers }
  );
  return data;
};

/** Head: return to HR. { answers } */
export const returnZaz = async (employeeId, zazId, answers) => {
  const { data } = await axiosClient.post(
    `${BASE}/employee/${employeeId}/${zazId}/return`,
    { answers }
  );
  return data;
};

export const downloadZazPdf = async (employeeId, zazId) => {
  const response = await axiosClient.get(
    `${BASE}/employee/${employeeId}/${zazId}/pdf`,
    { responseType: 'blob' }
  );
  const fileName =
    extractFileNameFromDisposition(response.headers['content-disposition']) ||
    'ZAZ.pdf';
  saveBlobAsFile(response.data, 'application/pdf', fileName);
};
